<template>
    <el-dialog
        class="site-deploy"
        title="场地配置"
        :visible.sync="dialogVisible"
        top="5vh"
        width="95%"
        :append-to-body='true'
        @closed="reset"
        :modal-append-to-body='false'>
        <div class="site-box">
          <div class="level-bar">
            <el-button @click="chooseclublevel(item.key)" v-for='(item,index) in clublevel' :key="index"  type="text" :class="chooseclublevelNumber===item.key?'choice':'nochoice'">{{item.name}}</el-button>
          </div>
          <div class="table-scroll">
            <el-table
                class="table"
                :header-row-class-name="table_header"
                header-cell-class-name="table_cell"
                :cell-class-name="table_cell"
                v-for="(which,index1) in total_data"
                :key="index1"
                :data="which.table_data"
                v-loading="loading_status"
                >
              <el-table-column prop="title" :label="which.round"  align="center" width="200px"></el-table-column>
              <el-table-column
                v-for="(item, index2) in which.group_data"
                :key="index2"
                :label="`
                  ${item.title}
                  ${which.round === '1R' ? `
                    \u3000\u3000\u3000\u3000\u3000
                    ${firstFormat[ruleForm.firstFormat] || ''}
                    \u3000\u3000\u3000\u3000\u3000
                    ${secondFormat[ruleForm.secondFormat] || ''}
                  ` : ''}
                `"
                align="center"
              >
                <template v-if="which.round === '1R' && item.label_data[0].tip">
                  <el-table-column v-for="(cell, index4) in tableCellCom(item.label_data)" :key="index4" :label="cell[0].tip" align="center">
                    <div>
                      <el-table-column v-for="(every, index5) in cell" :key="index5" :prop="every.prop" :label="every.label" align="center">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row[every.prop]" placeholder="场地号"></el-input>
                        </template>
                      </el-table-column>
                    </div>
                  </el-table-column>
                </template>
                <template v-else>
                  <el-table-column v-for="(every,index3) in item.label_data" :key="index3" :prop="every.prop" :label="every.label" align="center">
                      <template slot-scope="scope">
                          <el-input v-model="scope.row[every.prop]" placeholder="场地号"></el-input>
                      </template>
                  </el-table-column>
                </template>
              </el-table-column>
          </el-table>
          <div v-if="!total_data.length" class="empty-tip">暂无场地数据</div>
          </div>
          <div class="btn_box">
              <el-button  @click="cancel">返回</el-button>
              <el-button class="save" type="primary" @click="submit">保 存</el-button>
          </div>
        </div>
    </el-dialog>
</template>
<script>
import {
  GetCtRound,
  Query,
  Update
} from '@/api/pages/ct/competition/club-level/site-deploy.js';
export default {
  data () {
    return {
      rounds0Key: '',
      dialogVisible: false,
      total_data: [],
      ctId: null,
      clublevel: [],
      chooseclublevelNumber: null,
      loading_status: false,
      ruleForm: {
        firstFormat: '',
        secondFormat: ''
      },
			firstFormat: {
				0: '淘汰附加赛',
				1: '小组循环赛',
				5: '淘汰赛',
				// 6: '6签位循环赛',
				7: '俱乐部队队碰赛'
      },
			secondFormat: {
				2: '同名次小组循环赛',
				3: '同名次淘汰附加赛',
				4: '交叉淘汰附加赛',
				5: '淘汰赛'
      }
    };
  },
  computed: {
    tableCellCom () {
      return function (arr) {
        const map = {}
        arr.forEach(item => {
          if (!map[item.tip]) {
            map[item.tip] = []
          }
          map[item.tip].push(item)
        })
        return Object.values(map)
      }
    }
  },
  methods: {
    init (rows) {
      let { id } = rows;
      this.ctId = id;
      GetCtRound(id).then(data => {
        if (data && data.code === 0) {
          this.clublevel = data.rounds;
          this.chooseclublevelNumber = data.rounds[0].key;
          this.rounds0Key = data.rounds[0].key;
          this.round_query();
        } else {
          this.clublevel = [];
          this.chooseclublevelNumber = null;
        }
      });
    },
    chooseclublevel (val) {
      if (this.chooseclublevelNumber !== val) {
        this.$confirm(
          '离开当前页面，未保存的信息会丢失，是否确定离开？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(async () => {
            this.chooseclublevelNumber = val;
            this.total_data = [];
            this.round_query();
          })
          .catch(() => {});
      }
    },
    round_query () {
      this.loading_status = true;
      let params = {
        ctId: this.ctId,
        clubLevel: this.chooseclublevelNumber
      };
      Query(params).then(data => {
        if (data && data.code === 0) {
          if (!data.data) {
            this.$confirm(`您好，暂未生成场地信息。`, '提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              type: 'warning'
            }).then(async () => {
              // this.chooseclublevelNumber = this.rounds0Key;
              // this.round_query();
            });
            return false;
          }
          this.total_data = [];
          let { matchName, firstStage, secondStage, firstFormat, secondFormat } = data.data;
          this.ruleForm.firstFormat = firstFormat
          this.ruleForm.secondFormat = secondFormat
          // 处理数据
          secondStage = secondStage === null ? [] : secondStage;
          let res = firstStage.concat(secondStage);
          res.forEach((which, which_ind) => {
            let { round, againstSignList } = which;
            let title_data = [];
            let label_data = [];
            let table_data = [
              { title: '第一双打' },
              { title: '第二双打' },
              { title: '第三双打' }
            ];

            againstSignList.forEach(item => {
              // 解构赋值
              let {
                againstLabel,
                againstSign,
                competitionTerrainId,
                competitionTerrainOne,
                competitionTerrainTwo,
                competitionTerrainThree,
                remark
              } = item;
              if (which_ind === 0) {
                remark = matchName;
              }
              // 表格title(胜者(1-8))
              if (title_data.indexOf(remark) == -1) {
                title_data.push(remark);
              }
              // 表格label(胜VS胜)
              let obj = {
                tip: againstLabel,
                label: againstSign,
                prop: competitionTerrainId
              };
              label_data.push(obj);
              // table每一项的值
              table_data[0][competitionTerrainId] = competitionTerrainOne;
              table_data[1][competitionTerrainId] = competitionTerrainTwo;
              table_data[2][competitionTerrainId] = competitionTerrainThree;
            });
            // 分组
            let group_data = [];
            let end_ind = label_data.length / title_data.length;
            title_data.forEach((item, index) => {
              let obj = {
                title: item,
                label_data: label_data.splice(0, end_ind)
              };
              group_data.push(obj);
            });

            let tmp = {
              group_data,
              table_data,
              round: round + 'R'
            };
            this.total_data.push(tmp);
          });
           
          this.dialogVisible = true;
          this.loading_status = false;
        }
      });
    },
    table_header ({ rowIndex }) {
      switch (rowIndex) {
        case 0:
          return 'header_headline table_header';
        case 1:
          return 'header_subtitle table_header';
        case 2:
          return 'header_subtitle table_header';
        default:
          break;
      }
    },
    table_cell ({ column }) {
      let { label } = column;
      if (
        label === '1R' ||
        label === '2R' ||
        label === '3R' ||
        label === '4R'
      ) {
        return 'table_cell cell_title';
      } else {
        return 'table_cell';
      }
    },
    submit () {
      // 处理数据
      let res_data = [];
      this.total_data.forEach(which => {
        let arr_tmp = [];
        let { table_data, round } = which;
        let keys = Object.keys(table_data[0]);
        keys.forEach(item_key => {
          if (item_key !== 'title') {
            let obj = {};
            obj.ctId = this.ctId;
            obj.competitionTerrainId = item_key;
            obj.competitionTerrainOne = table_data[0][item_key];
            obj.competitionTerrainTwo = table_data[1][item_key];
            obj.competitionTerrainThree = table_data[2][item_key];
            arr_tmp.push(obj);
          }
        });
        res_data = res_data.concat(arr_tmp);
      });
      let data = res_data;
      Update(data).then(res => {
        this.$message.success(res.data);
      });
    },
    cancel () {
      this.dialogVisible = false;
    },
    reset () {
      this.total_data = [];
      this.ctId = null;
      this.clublevel = [];
      this.chooseclublevelNumber = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.site-deploy {
  .site-box {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 200px);
    .level-bar {
      flex-shrink: 0;
      padding-bottom: 12px;
    }
    .table-scroll {
      flex: 1;
      min-height: 400px;
      overflow-y: auto;
      box-sizing: border-box;
      .empty-tip {
        text-align: center;
        color: #909399;
        font-size: 22px;
        padding: 80px 0;
      }
    }
    .table {
      margin: 20px 0 30px;
      border: 1px #000 solid;
    }
    .btn_box {
      flex-shrink: 0;
      display: flex;
      flex-direction: row-reverse;
      padding-top: 12px;
      .save {
        margin-right: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.site-deploy {
  .table {
    td {
      padding: 0;
    }
    .el-table__row .cell .el-input__inner {
      border: none;
      text-align: center;
      &::-webkit-input-placeholder {
        color: #606266;
      }
      &::-moz-input-placeholder {
        color: #606266;
      }
      &::-ms-input-placeholder {
        color: #606266;
      }
    }
    .table_header {
      th {
        background: #d9e1f2 !important;
        color: #000;
      }
    }
    .header_headline {
      th {
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
    .header_subtitle {
      th {
        font-weight: 400;
      }
    }
    .table_cell {
      border-color: #000;
    }
    .cell_title {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
